import { LOCATION_CHANGE, push } from 'connected-react-router';
import { createMiddleware } from '../../../shared/redux';
import { match } from '../../../shared/utils/match';
import * as AuthService from '../auth-service';
import {
    getUser,
    isSignInFromSignUp,
    rejectSignIn,
    setUser,
} from '../sign-in/sign-in.state';
import {
    acceptChallengeSmsMfa,
    CHALLENGE_SMS_MFA_ACCEPTED,
    CHALLENGE_SMS_MFA_ISSUED,
    CHALLENGE_SMS_MFA_REJECTED,
    CHALLENGE_SMS_MFA_SUBMITTED,
    rejectChallengeSmsMfa,
} from './challenge-sms-mfa-state';
import { ROUTES } from '../auth.constants';
import { redirectToSplashScreen } from '../splash-screen/splash-screen-state';

export const challengeSmsMfaMiddleware = createMiddleware({
    [LOCATION_CHANGE]: match((_, action) => action.payload.location.pathname, {
        [ROUTES.CHALLENGE_SMS_MFA]: state => (getUser(state) ? null : push('/auth/sign-in')),
    }),

    [CHALLENGE_SMS_MFA_ISSUED]: () => push(ROUTES.CHALLENGE_SMS_MFA),
    [CHALLENGE_SMS_MFA_SUBMITTED]: (state, action) => (
        AuthService.confirmSignIn({ user: getUser(state), code: action.payload.code, mfaType: 'SMS_MFA' })
            .then(user => acceptChallengeSmsMfa({ user }))
            .catch(error => rejectChallengeSmsMfa({ code: error.code || 'UnknownException', error }))
    ),
    [CHALLENGE_SMS_MFA_ACCEPTED]: (state, action) => ([
        setUser({ user: action.payload.user }),
        redirectToSplashScreen(),
    ]),
    [CHALLENGE_SMS_MFA_REJECTED]: (state, action) => (
        rejectSignIn({
            code: action.payload.code,
            error: action.payload.error,
            fromSignUp: isSignInFromSignUp(state),
        })
    ),
});
